// Elements
import Button from "./button/button";
import Input from "./input/input";
import Select from "./select/select";
import Checkbox from "./checkbox/checkbox";

// UIs
import Header from "./header/header";
import Footer from "./footer/footer";
import Intro from "./intro/intro";
import Intros from "./intros/intros";
import Service from "./service/service";
import Services from "./services/services";
import Sidebar from "./sidebar/sidebar";
import Map from "./map/map";
import MapDemo from "./map-demo/map-demo";
import AddressBar from "./address-bar/address-bar";
import MobileMenu from "./mobile-menu/mmenu";
import ServiceCarousel from "./services-carousel/servicesCarousel";
import DemoCarousel from "./demo-carousel/demoCarousel";
import ServicesList from "./services-list/services-list";
import ServiceDetail from "./service-detail/service-detail";
import DemoIntro from "./demo-intro/demo-intro";
import DemoVRPInfo from "./demo-vrp-info/demo-vrp-info";
import UnderConstruction from "./under-construction/under-construction";
import Page404 from "./page404/page404";
import MessageBox from "./message-box/message-box";

//Context APIs
import MapDemoContext from "./map-demo/map-demo-Context";
import MapDemoProvider from "./map-demo/map-demo-Provider";

// Demos
import Tsp from "./tsp/tsp";
import Vrp from "./vrp/vrp";

export {
  Button,
  Input,
  Select,
  Checkbox,
  Header,
  Footer,
  Intro,
  Intros,
  Service,
  Services,
  Sidebar,
  Map,
  MapDemo,
  AddressBar,
  MobileMenu,
  ServiceCarousel,
  DemoCarousel,
  ServicesList,
  ServiceDetail,
  DemoIntro,
  DemoVRPInfo,
  Tsp,
  Vrp,
  UnderConstruction,
  Page404,
  MessageBox,
  MapDemoContext,
  MapDemoProvider
};

export function dimport(demoName) {
  switch (demoName) {
    case "tsp":
      return Tsp;
    case "vrp":
      return Vrp;
    default:
      break;
  }
}

export function dimportIntro(page) {
  switch (page) {
    case "MapDemo":
      return MapDemo;
    case "DemoIntro":
      return DemoIntro;
    case "DemoVRPInfo":
      return DemoVRPInfo;
    default:
      break;
  }
}
